var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H42C60.8562 0 70.2843 0 76.1421 5.85786C82 11.7157 82 21.1438 82 40V42C82 60.8562 82 70.2843 76.1421 76.1421C70.2843 82 60.8562 82 42 82H40C21.1438 82 11.7157 82 5.85786 76.1421C0 70.2843 0 60.8562 0 42V40Z",
    fill: "#FF6250",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.4353 55.8148C31.3131 55.9389 31.1676 56.0373 31.007 56.1046C30.8465 56.1718 30.6742 56.2064 30.5001 56.2064C30.326 56.2064 30.1537 56.1718 29.9932 56.1046C29.8326 56.0373 29.6871 55.9389 29.5649 55.8148L26.1853 52.4352C26.0612 52.313 25.9628 52.1675 25.8955 52.0069C25.8283 51.8464 25.7937 51.6741 25.7937 51.5C25.7937 51.3259 25.8283 51.1536 25.8955 50.9931C25.9628 50.8325 26.0612 50.687 26.1853 50.5648L43.6251 33.125L48.8751 38.375L31.4353 55.8148Z",
    fill: "#FF6250"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4375 41V48.875",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 44.9375H59.375",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7812 26.5625V33.125",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29.8438H37.0625",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5625 50.1875V55.4375",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9375 52.8125H50.1875",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5854 26.174L26.1886 50.5708C25.676 51.0834 25.676 51.9144 26.1886 52.427L29.5819 55.8203C30.0944 56.3328 30.9255 56.3328 31.438 55.8203L55.8349 31.4234C56.3474 30.9109 56.3474 30.0798 55.8349 29.5673L52.4416 26.174C51.929 25.6614 51.098 25.6614 50.5854 26.174Z",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.625 33.125L48.875 38.375",
    stroke: "#FF6250",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartJobIcon);
export default __webpack_public_path__ + "static/media/smart-job-icon.e6a6fb4de8b5e98211a66120a3f2f186.svg";
export { ForwardRef as ReactComponent };